export default "__VITE_ASSET__Bf5U6EDI__"